import * as Yup from 'yup';
import { asignarEncuestaFormModel } from './asignarEncuestaFormModel';

const {
  formField: { deviceManagementId, surveyId },
} = asignarEncuestaFormModel;

export const validationSchema = Yup.object().shape({
  [deviceManagementId.name]: Yup.mixed().required(deviceManagementId.requiredErrorMsg),
  [surveyId.name]: Yup.array()
    .min(1, surveyId.requiredErrorMsg)
    .required(surveyId.requiredErrorMsg),
});
